module.exports = __webpack_public_path__ + "static/img/funny_07.fc865d63.jpg";